import { Alert, AppShell, Box, Button, Center, Container, Group, Loader, Text } from "@mantine/core"
import { notifications } from "@mantine/notifications"
import { IconInfoCircle, IconRefresh } from "@tabler/icons-react"

import { HealthOverview } from "@/components/HealthOverview"
import { Navbar } from "@/components/Navbar"
import { useMultiServiceHealth } from "@/hooks/useMultiServiceHealth"

export function DashboardPage() {
  const healthData = useMultiServiceHealth()

  const handleRefresh = () => {
    // Force a refetch by invalidating the query
    window.location.reload()
    notifications.show({
      title: "Refreshing...",
      message: "Reloading health status",
      color: "blue",
    })
  }

  return (
    <AppShell padding="md">
      <Navbar onRefresh={handleRefresh} isRefreshing={healthData.isLoading} />

      <AppShell.Main>
        <Container size="xl" py="md">
          {/* Actions Bar */}
          <Group justify="space-between" mb="lg">
            <Text size="xl" fw={600}>
              Platform Health Dashboard
            </Text>

            <Group>
              <Button leftSection={<IconRefresh size={16} />} onClick={handleRefresh} loading={healthData.isLoading}>
                Refresh Status
              </Button>
            </Group>
          </Group>

          {/* Loading State */}
          {healthData.isLoading && Object.keys(healthData.services).length === 0 && (
            <Center py="xl">
              <Box ta="center">
                <Loader size="lg" mb="md" />
                <Text>Loading service health status...</Text>
              </Box>
            </Center>
          )}

          {/* Health Overview */}
          {Object.keys(healthData.services).length > 0 && <HealthOverview healthData={healthData} />}

          {/* Info Alert */}
          <Alert icon={<IconInfoCircle size="1rem" />} title="About this dashboard" color="blue" mt="xl">
            This dashboard monitors the health of all Agent Platform services. Status is automatically refreshed every
            30 seconds. Each service is checked independently for availability and health.
          </Alert>
        </Container>
      </AppShell.Main>
    </AppShell>
  )
}
